import draggable from 'vuedraggable'
import vSelect from 'vue-select'
import Editor from '@tinymce/tinymce-vue'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import ProjectTable from '../project-listing.vue'
import { mapActions } from 'vuex'
import { contentFileUpload} from '@/api/course-builderapi'
import {priorityList, createLog, projectList, taskShow, taskUpdate, taskList } from '@/api/task-project.js'
export const TaskProject = {
  components: {
    draggable,
    'editor': Editor,
    'v-select': vSelect,
    flatPickr,
    ProjectTable
  },
  data () {
    return {
      options: [
        {id: 1, status: 'To Do'},
        {id: 2, status: 'In Progress'},  
        {id: 3, status: 'Done'}
      ],
      showDataForProject: {},
      parentTaskData: [],
      selectedSubTask: [],
      selectedCRM: [],
      selectedCRMData: [],
      reminderTime: [],
      tagsList: [],
      leadData: [],
      ListOfProject: [],
      selectedProjectsData: [],
      selectedSubTaskData: [],
      selectedProjects: [],
      popupActiveProj: false,
      popupActiveSubTask: false,
      popupActiveCRM: false,
      kanbanActive: false,
      live_update_id: '',
      update_id: '',
      openUpdateModal: false,
      userInfo: JSON.parse(localStorage.getItem('Clientuser')),
      configdateTimePicker1: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: false
      },
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: false,
        maxDate: ''
      },
      navmenuItems: 2,
      typeOfPerson:'',
      responsibleData: [],
      participantData: [],
      observerData: [],
      rows: [],
      checklistRows: [],
      checkBox1: '',
      query_page_user: {
        page: 1
      },
      query_page_client: {
        page: 1
      },
      currentPageUser: '',
      currentPageClient: '',
      showButtonClient: true,
      showButtonUser: true,
      clientList: [],
      userList: [],
      selectedUsers: [],
      selectedClients: [],
      taskData: {
        name : '',
        due_date: '',
        task_priority_id : '',
        comments: '',
        details: '',
        is_tracking_active: false,
        created_by: {},
        clientObserver:[],
        clientParticipant:[],
        clientResponsiblePerson:[],
        userObserver:[],
        userParticipant:[],
        userResponsiblePerson:[],
        from_time: '',
        to_time: '',
        is_template: false,
        checklist:[],
        projectStatusTag: '',
        task_status_id: '',
        projects: [],
        tags: [],
        subtask: [],
        leads: [],
        reminder: []
      },
      logs: [
        {
          no_of_days: '',
          no_of_hours: ''}
      ],
      logHistory: [],
      priority: [],
      image_url: '',
      tinyMceApi:'',
      selectedTab: null,
      popupActive: false,
      statusActive: false,
      importActive: false,
      primary: '#41cfdd',
      date: '',
      time: null,
      task: true,
      project: false,
      projectId: '',
      allTaskStatus: [],
      statusname: '',
      selected: [],
      selectedData: [],
      ListOfLiveTaskUpdate: [],
      ListOfTaskUpdate: [],
      meta_template: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      meta_task: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      meta: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      sub_meta: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      leadMeta: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      tag_meta: {
        current_page: 1,
        has_next: true,
        limit: 20,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      leadQuery: {
        page: 1,
        limit: 10,
        customerId: this.$store.getters.customerId
      },
      query_page_data: {
        page: 1,
        limit: 10
      }
    }
  },
  created () {
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
    // const customer_id = localStorage.getItem('customer_id')
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.image_url = `${imageUploadUrl}${this.customer_id}`
  },
  methods: {
    ...mapActions(['SET_ADD_ID']),
    addLog () {
      this.logs.push({
        no_of_days: '',
        no_of_hours: ''
      })
    },
    updateCalendar () {
      this.configdateTimePicker.maxDate = this.taskData.due_date.split(' ')[0]
    },
    priorityList () {
      priorityList()
        .then((res) => {
          console.log(res.data.data.priorities)
          this.priority = res.data.data.priorities
        })
        .catch((e) => {
          console.log(e)
        })
    },
    
    addMoreUser (data) {
      this.popupActive = true 
      this.typeOfPerson = data
    },
   
    addItem (checklist) {
      checklist.showTextBox.push({itemName: ''})
    },
    removeItem (data, index2) { 
      data.showTextBox.splice(index2, 1)
    },
    addChecklist () {
      this.checklistRows.push({
        showTextBox: [],
        items: [],
        itemStatusCal: []
      })   
    },
    removeChecklist (index) {
      this.checklistRows.splice(index, 1)
    },   
    submitItem (index3, data) { 
      for (let index = 0; index < data.showTextBox.length; index++) {
        if (data.showTextBox[index].itemName !== '') {
          this.checklistRows[index3].items.push({
            todo: data.showTextBox[index].itemName,
            is_completed: false
          })
        }
      }
      for (let index = 0; index < data.showTextBox.length; index++) {
        data.showTextBox[index].itemName = ''
      }
      this.checklistRows[index3].showTextBox = []  
    },
    deleteItem (index3, index) {
      if (this.live_update_id) {
        if (this.taskData.checklist.length !== 0) {
          if (this.taskData.checklist[index3].todos.length === 1) {
            this.taskData.checklist.splice(index, 1)
          } else {
            if (this.taskData.checklist[index3].todos[index].is_completed === true) {
              this.taskData.checklist[index3].itemStatusCal.length = this.taskData.checklist[index3].itemStatusCal.length - 1
            }
            this.taskData.checklist[index3].todos.splice(index, 1)
          }
        }
      }
    },
    deleteItemFromCheck (index3, index) {
      if (this.checklistRows.length !== 0) {
        if (this.checklistRows[index3].items.length === 1) {
          this.checklistRows.splice(index, 1)
        } else {
          if (this.checklistRows[index3].items[index].is_completed === true) {
            this.checklistRows[index3].itemStatusCal.length = this.checklistRows[index3].itemStatusCal.length - 1
          }
          this.checklistRows[index3].items.splice(index, 1) 
        }
      }
    },
    changeStatus (index3, index) {
      if (this.taskData.checklist.length !== 0) {
        if (this.taskData.checklist[index3].todos[index].is_completed === true) {
          this.taskData.checklist[index3].todos[index].is_completed = true
          this.taskData.checklist[index3].itemStatusCal.length = this.taskData.checklist[index3].itemStatusCal.length + 1
        } else {
          this.taskData.checklist[index3].todos[index].is_completed = false
          this.taskData.checklist[index3].itemStatusCal.length = this.taskData.checklist[index3].itemStatusCal.length - 1
        }
      }
        
    },
    changeStatusFromCheck (index3, index) {
      if (this.checklistRows.length !== 0) {
        if (this.checklistRows[index3].items[index].is_completed === true) {
          this.checklistRows[index3].items[index].is_completed = true
          this.checklistRows[index3].itemStatusCal.length = this.checklistRows[index3].itemStatusCal.length + 1
        } else {
          this.checklistRows[index3].items[index].is_completed = false
          this.checklistRows[index3].itemStatusCal.length = this.checklistRows[index3].itemStatusCal.length - 1 
        }
      }
        
    },
    clearData () {
      this.taskData.name = ''
      this.taskData.due_date = ''
      this.taskData.status = ''
      this.taskData.projectStatusTag = ''
      this.taskData.task_priority_id = ''
      this.taskData.comments = ''
      this.taskData.details = ''
      this.taskData.clientObserver = []
      this.taskData.clientParticipant = []
      this.taskData.clientResponsiblePerson = []
      this.taskData.userObserver = []
      this.taskData.userParticipant = []
      this.taskData.userResponsiblePerson = []
      this.taskData.from_time = ''
      this.taskData.to_time = ''
      this.taskData.is_template = false
      this.taskData.projects = []
      this.taskData.subtask = []
      this.taskData.reminder = []
      this.taskData.is_tracking_active = false
      this.taskData.created_by = {}
      this.taskData.leads = []
      this.taskData.tags = []
      this.responsibleData = []
      this.participantData = []
      this.observerData = []
      this.selectedSubTaskData = []
      this.selectedCRMData = []
      this.selectedProjectsData = []
      this.reminderTime = []
      this.update_id = ''
      this.live_update_id = ''
      this.checklistRows = []
    },
    async fetchTaskUpdate (query) {
      try {
        this.$vs.loading({
          type: 'radius'
        })
        const { data } = await taskList(query)
        this.meta_task = data.data.meta_task
        const liveTable = data.data.tasks
        liveTable.map((row, index) => {
          const row_index = index + 1
          const status_list = this.priority
          const live_status_list = this.options
          Object.assign(row, { row_index })
          Object.assign(row, { status_list })
          Object.assign(row, { live_status_list })
        })
        this.ListOfLiveTaskUpdate = liveTable
        this.$vs.loading.close()
        console.log(this.ListOfLiveTaskUpdate)
      } catch (e) {
        console.log(e)
        this.$vs.loading.close()
      }
    },
    submitLog (id) {
      const payload = {
        logs: this.logs
      }
      createLog(id, payload)
        .then((res) => {
          console.log(res.data.data.tasks)
          this.logs = [
            {
              no_of_days: '',
              no_of_hours: ''
            }
          ]
          for (let index = 0; index < res.data.data.tasks.length; index++) {
            this.logHistory.push({
              no_of_days: res.data.data.tasks[index].no_of_days,
              no_of_hours: res.data.data.tasks[index].no_of_hours
            }) 
          }
          this.successMessage('Successfull')
        })
        .catch((e) => {
          console.log(e)
          this.warningMessage('Something Went Wrong')
        })
    },
    images_upload_handler (blobInfo, success, failure) {
      console.log('hi')
      console.log(blobInfo)
    
      const xhr = new XMLHttpRequest()
      xhr.withCredentials = true
      xhr.open('POST', this.image_url)
    
      xhr.upload.onprogress = function (e) {
        // eslint-disable-next-line no-undef
        progress((e.loaded / e.total) * 100)
      }
    
      xhr.onload = function () {
        // let json
    
        if (xhr.status === 403) {
          failure(`HTTP Error: ${xhr.status}`, { remove: true })
          return
        }
    
        if (xhr.status < 200 || xhr.status >= 300) {
          failure(`HTTP Error: ${xhr.status}`)
          return
        }
    
        const json = JSON.parse(xhr.responseText)
    
        if (!json || typeof json.location !== 'string') {
          failure(`Invalid JSON: ${xhr.responseText}`)
          return
        }
    
        success(json.location)
      }
    
      xhr.onerror = function () {
        failure(
          `Image upload failed due to a XHR Transport error. Code: ${xhr.status}`
        )
      }
    
      xhr.setRequestHeader(
        'Authorization',
        `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`
      )
    
      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob(), blobInfo.filename())
    
      console.log(formData)
    
      xhr.send(formData)
    },
    example_image_upload_handler (blobInfo, success) {
      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob())
      const data = this.fileupload(formData)
      data
        .then((res) => {
          console.log(res)
          const locationObject = {
            src: {
              value: {
                location: res
              }
            }
          }
          const stringify = JSON.stringify(res)
          const parse = JSON.parse(stringify)
          console.log(locationObject)
          success(parse)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async fileupload (payload) {
      try {
        // const customer_id = localStorage.getItem('customer_id')
    
        console.log(payload)
    
        const responseImage = await contentFileUpload(this.customer_id, payload)
        const location =
              responseImage.data.data.cdn +
              responseImage.data.data.files[0].file_path
        this.successMessage('Image Uploaded Successfully')
        return location
      } catch (error) {
        console.log(error)
      }
    },
    mainTab (type) {
      if (type === 'task') {
        this.task = true
        this.project = false
      } else if (type === 'project') {
        this.task = false
        this.project = true
      }
    },
    openModalSectionLive (data) {
      this.live_update_id = data.data.id
      taskShow(data.data.id)
        .then((res) => {
          const task = res.data.data.task
          console.log(task)
          this.taskData.name = task.name
          this.taskData.due_date = task.due_date
          this.taskData.task_priority_id = task.task_priority.id
          this.taskData.comments = task.comments
          this.taskData.created_by = task.created_by
          this.taskData.is_tracking_active = task.is_tracking_active
          this.taskData.details = task.details
          this.taskData.checklist = task.checklist
          this.taskData.task_status_id = task.status.id
          this.taskData.checklist.map((row, index) => {
            const itemStatusCal = this.taskData.checklist[index].todos.filter(ele => {
              return ele.is_completed === true
            })
            Object.assign(row, { itemStatusCal })
          })
          this.taskData.from_time = task.from_time
          this.taskData.to_time = task.to_time
          this.logHistory = []
          for (let index = 0; index < task.logs.length; index++) {
            this.logHistory.push({
              no_of_days: task.logs[index].no_of_days,
              no_of_hours: task.logs[index].no_of_hours
            }) 
          }
          this.taskData.is_template = false
          this.taskData.details = task.details
          this.taskData.clientObserver = task.clientObserver
          this.taskData.clientParticipant = task.clientParticipant
          this.taskData.clientResponsiblePerson = task.clientResponsiblePerson
          this.taskData.userObserver = task.userObserver
          this.taskData.userParticipant = task.userParticipant
          this.responsibleData = task.userResponsiblePerson.concat(task.clientResponsiblePerson)
          this.participantData = task.userParticipant.concat(task.clientParticipant)
          this.observerData = task.userObserver.concat(task.clientObserver) 
          this.selectedSubTaskData = task.subtask
          this.showDataForProject = task.project
          this.taskData.tags = task.tags
          this.selectedCRMData = task.leads
          if (task.taskReminder.length !== 0) {
            for (let index = 0; index < task.taskReminder.length; index++) {
              this.addReminder()
            }
            for (let index = 0; index < task.taskReminder.length; index++) {
              this.reminderTime[index].reminder_time = task.taskReminder[index].reminder_time
            }
          }

        })
        .catch((e) => {
          console.log(e)
        })
      this.openUpdateModal = true
    },
    addReminder () {
      this.reminderTime.push({id: null,
        reminder_time: ''})
    },
    showModalForEdit (item) {
      this.live_update_id = item.id
      taskShow(item.id)
        .then((res) => {
          const task = res.data.data.task
          console.log(task)
          this.taskData.name = task.name
          this.taskData.due_date = task.due_date
          this.taskData.task_priority_id = task.task_priority.id
          this.taskData.comments = task.comments
          this.taskData.created_by = task.created_by
          this.taskData.is_tracking_active = task.is_tracking_active
          this.taskData.details = task.details
          this.taskData.task_status_id = task.status.id
          // this.taskData.projectStatusTag = task.projectStatusTag.name // data is not present
          this.taskData.checklist = task.checklist
          this.taskData.checklist.map((row, index) => {
            const itemStatusCal = this.taskData.checklist[index].todos.filter(ele => {
              return ele.is_completed === true
            })
            Object.assign(row, { itemStatusCal })
          })
          this.taskData.from_time = task.from_time
          this.taskData.to_time = task.to_time
          this.logHistory = []
          for (let index = 0; index < task.logs.length; index++) {
            this.logHistory.push({
              no_of_days: task.logs[index].no_of_days,
              no_of_hours: task.logs[index].no_of_hours
            }) 
          }
          this.taskData.is_template = false
          this.taskData.details = task.details
          this.taskData.clientObserver = task.clientObserver
          this.taskData.clientParticipant = task.clientParticipant
          this.taskData.clientResponsiblePerson = task.clientResponsiblePerson
          this.taskData.userObserver = task.userObserver
          this.taskData.userParticipant = task.userParticipant
          this.responsibleData = task.userResponsiblePerson.concat(task.clientResponsiblePerson)
          this.participantData = task.userParticipant.concat(task.clientParticipant)
          this.observerData = task.userObserver.concat(task.clientObserver)
          this.selectedSubTaskData = task.subtask
          this.showDataForProject = task.project
          this.taskData.tags = task.tags
          this.selectedCRMData = task.leads
          if (task.taskReminder.length !== 0) {
            for (let index = 0; index < task.taskReminder.length; index++) {
              this.addReminder()
            }
            for (let index = 0; index < task.taskReminder.length; index++) {
              this.reminderTime[index].reminder_time = task.taskReminder[index].reminder_time
            }
          }
        })
        .catch((e) => {
          console.log(e)
        })
      this.kanbanActive = true    
    },
    addModal (data) {
      if (data === 'project') {
        this.popupActiveProj = true
      } else if (data === 'subTask') {
        this.popupActiveSubTask = true
      } else {
        this.popupActiveCRM = true
      }
    },
    async fetchProject (query) {
      try {
        this.$vs.loading({
          type: 'radius'
        })
        const { data } = await projectList(query)
        const table = data.data.project
        this.meta = data.data.meta
        table.map((row, index) => {
          const row_index = index + 1
          Object.assign(row, { row_index })
        })
        this.$vs.loading.close()
        this.ListOfProject = table
        console.log(table)
      } catch (e) {
        console.log(e)
        this.$vs.loading.close()
      }
    },
    StatusChnage (data) {
      const payload = {
        updateField: {task_status_id: data.task_status_id}
      }
      taskUpdate(this.live_update_id, payload)
        .then((res) => {
          this.successMessage('Status changed successfully')
          res.data.data.task.status_list = this.priority
          res.data.data.task.live_status_list = this.options
          const afterUpdate = [res.data.data.task]
          this.ListOfLiveTaskUpdate = this.ListOfLiveTaskUpdate.map(obj => afterUpdate.find(o => o.id === obj.id) || obj)
        })
        .catch((e) => {
          console.log(e)
          this.warningMessage('Something went wrong')
        })
    },
    successMessage (msg) {
      this.$vs.notify({
        title: 'Success',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    }, 
    warningMessage (msg) {
      this.$vs.notify({
        title: 'Warning',
        text: msg,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
        time: 3000
      })
    }
  }
}
